/**
 * @Author: wuyang
 * @Date: 2024/1/30
 * @Description: ""
 */
import { BaseQueryClient } from '@/helper/query/client'
import { QueryClient } from '@tanstack/react-query'

const baseQueryClient = new BaseQueryClient({})

export const getBaseQueryClient = () => {
	return baseQueryClient as QueryClient
}
